import { Illustration } from '@mint-lib/illustrations';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  message: string;
  subText?: string;
};

const EmptyMessage = ({ message, subText }: Props) => {
  return (
    <div className="flex flex-col items-center gap-4">
      <Illustration className="size-40" component="IllustrationEmptyState" />
      <p className={cn(typographyVariants({ variant: 'h4' }), 'gap-2')}>
        {message}
      </p>
      {subText && (
        <p
          className={typographyVariants({
            variant: 'bodyShort01',
            color: 'secondary',
          })}
        >
          {subText}
        </p>
      )}
    </div>
  );
};

export default EmptyMessage;
